import { useMutation, useQueryClient  } from "@tanstack/react-query";
import { useState, useEffect } from 'react';
import { usePassport } from '../../../../hooks/usePassport';

const PassportModal = ({id, onClose,}: {id?: string; onClose: () => void;}) => {
    const API_URL = import.meta.env.VITE_API_URL;
    const queryClient = useQueryClient();

	const { passport, existPassword, existPassport } = usePassport(id);
	const [editGradeValue, setEditGradeValue] = useState();
	
	const changeMutation = useMutation({
		mutationFn: async (data: { childId: string, grade: string }) => {
			const params = new URLSearchParams();
			Object.entries(data).forEach(([key, value]) => {
				params.append(key, value);
			});

			const response = await fetch(`${API_URL}/bbs/ajax.update_passport_info.php`, {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
				},
				body: params,
			});

			if (!response.ok) throw new Error("네트워크 오류");

			return response.json();
		},
		onSuccess: (response) => {
			if (!response.success) {
				switch (response.code) {
					case "UNAUTHORIZED":
					case "NOT_FOUND_MEMBER":
						setSubmitError("인증된 사용자가 아닙니다.");
						break;
					case "INVALID_REQUEST":
						setSubmitError("필수 필드값이 입력되지 않았습니다.");
						break;
					default:
						setSubmitError("알 수 없는 오류가 발생했습니다.");
						break;
				}
				return;
			}

			if (!response.data) {
				setSubmitError("알 수 없는 오류가 발생했습니다.");
				return;
			}

			if (response.data.memberId) {
				queryClient.invalidateQueries({ queryKey: ['passportList'] });
				queryClient.invalidateQueries({ queryKey: ['member'] });
				onClose();
			}
		},
		onError: (error: any) => {
			setSubmitError(error.message);
		}
	});

	const handleCompletePassport = () => {
		if(!confirm("여권의 학년정보를 변경하시겠습니까?")) return;
		changeMutation.mutate({childId: id, grade: editGradeValue});
	}

	useEffect(() => {
		if (passport?.grade) {
			setEditGradeValue(passport.grade);
		}
	}, [passport?.grade]);

	return (
		<div className="fixed inset-0 bg-black/70 z-[1000] flex items-center justify-center p-5 ">
			<div className="p-5 border rounded-xl bg-white space-y-2 shadow-sm min-w-[300px] max-w-[400px]">
				<div className="flex items-center justify-start gap-1 relative group">
					<label  className="block text-sm font-semibold text-gray-700 mb-1">
						이름
					</label>
                    <div className="relative">
                        <div className="w-4 h-4 rounded-full border border-gray-300 text-gray-400 text-[10px] flex items-center justify-center cursor-pointer bg-white">
                            ?
                        </div>
                        <div className="absolute bottom-6 right-0 hidden group-hover:block z-10">
                            <div className="bg-gray-900 text-white text-[10px] rounded-md px-2 py-1 whitespace-nowrap shadow-lg">
                                자녀 이름 변경 시 자동 반영됩니다.
                            </div>
                            <div className="absolute top-full right-2 w-2 h-2 bg-gray-900 rotate-45 -mt-1"></div>
                        </div>
                    </div>
                </div>
				<input
					type="text"
					placeholder="자녀 이름을 입력해주세요."
					value={passport?.name}
					disabled
					className="w-full sm:flex-1 px-4 py-3 rounded-lg border text-sm transition border-gray-300"
				/>
				<label  className="block text-sm font-semibold text-gray-700 mb-1">
					학년
				</label>
				<div className="relative">
					<select
						name="editGrade"
						id="editGrade"
						value={editGradeValue}
						onChange={(e) => setEditGradeValue(e.target.value)}
						disabled={changeMutation.isPending}
						className="w-full h-10 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-xs appearance-none pr-7"
					>
						<option value="1">초등 1학년</option>
						<option value="2">초등 2학년</option>
						<option value="3">초등 3학년</option>
						<option value="4">초등 4학년</option>
						<option value="5">초등 5학년</option>
						<option value="6">초등 6학년</option>
					</select>
					<i className="ri-arrow-down-s-line absolute right-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400"></i>
				</div>
				<div className="flex gap-2">
					<button
						type="button"
						onClick={onClose}
						className="w-full px-4 py-3 rounded-lg text-sm font-semibold transition whitespace-nowrap mt-2 bg-gray-200 transition-colors hover:bg-gray-300"
			        >
			            닫기
			        </button>
					<button
						type="button"
						onClick={handleCompletePassport}
						className="w-full px-4 py-3 rounded-lg text-sm font-semibold transition whitespace-nowrap mt-2 bg-purple-600 text-white hover:bg-purple-700">
			            입력 완료
			        </button>
				</div>
			</div>
		</div>
	);
}

export default PassportModal;